import * as styles from "./ParagraphContactUs.module.scss";

import React from "react";
import { Button } from "../../../components/common";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface ParagraphContactUsProps {
	title: string;
	phoneNumber: string;
	ctaTitle?: string;
	ctaUrl?: string;
	bodyHtmlText?: string;
	footerHtmlText?: string;
	jumpLinksTitle?: string;
}

export const getParagraphContactUsProps = ({
	relationships: {
		field_contact_us_node: {
			title,
			field_jump_links_title,
			field_contact_phone_number,
			field_cta,
			body,
			field_footer_text,
		},
	},
}: Queries.ParagraphContactUsDataFragment): ParagraphContactUsProps => ({
	title,
	phoneNumber: field_contact_phone_number,
	ctaTitle: field_cta?.title,
	ctaUrl: field_cta?.uri,
	bodyHtmlText: body?.value,
	footerHtmlText: field_footer_text?.value,
	jumpLinksTitle: field_jump_links_title,
});

export const ParagraphContactUs: React.FC<ParagraphContactUsProps> = ({
	title,
	phoneNumber,
	ctaTitle,
	ctaUrl,
	bodyHtmlText,
	footerHtmlText,
	jumpLinksTitle,
}) => {
	return (
		<WrappedSection
			sectionColour={Colours.WHITE}
			sectionName="ParagraphContactUs"
		>
			<div className={styles.paragraphcontactusinner}>
				{title && title.split("-")[0] !== "None" && (
					<div className={styles.title}>
						{jumpLinksTitle ? (
							<h2
								className={styles.heading}
								data-jumplinkstitle={jumpLinksTitle}
							>
								{title}
							</h2>
						) : (
							<h2 className={styles.heading}>{title}</h2>
						)}
					</div>
				)}
				{bodyHtmlText && (
					<div
						className={styles.bodytext}
						// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
						dangerouslySetInnerHTML={{
							__html: bodyHtmlText,
						}}
					/>
				)}
				<div className={styles.contactinfo}>
					{phoneNumber && (
						<p className={styles.phonetext}>
							{"Call us on "}
							<a href={`tel:${phoneNumber?.replace(/\s/g, "")}`}>
								{phoneNumber}
							</a>
						</p>
					)}
					{phoneNumber && ctaTitle && ctaUrl && (
						<p className={styles.lpreducedmargin}>or</p>
					)}
					<div className={styles.buttonwrapper}>
						<Button variant={"secondary"} url={ctaUrl} fullWidth={true}>
							{ctaTitle}
						</Button>
					</div>
					{footerHtmlText && (
						<div
							className={styles.highlightedtextarea}
							// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
							dangerouslySetInnerHTML={{
								__html: footerHtmlText,
							}}
						/>
					)}
				</div>
			</div>
		</WrappedSection>
	);
};

export default ParagraphContactUs;
